export const ERROR_TYPES = {
  VALIDATION_ERROR: 'ValidationError',
  DEVIATION_ERROR: 'DeviationError'
};

export class ValidationError extends Error {
  constructor(message) {
    super(message);
    this.type = ERROR_TYPES.VALIDATION_ERROR;
  }
}

export class DeviationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'DeviationError';
  }
}
